module.exports = __webpack_public_path__ + "img/t2-15.22f314b3.svg";